import secureLs from '@/libs/secureLs'

export const isKomtimOnly = () => {
  const userData = secureLs.getItem('userData')
  const productAbility = Object.entries(userData).filter(([key, value]) => key.startsWith('is_kom') && value === 1)
  return productAbility.length === 1 && productAbility[0][0] === 'is_komtim'
}

export const otherFunc = () => {}
